"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var messages = {
  state: {
    messages: []
  },
  getters: {
    getMessages: function getMessages(state) {
      return state.messages;
    },
    noErrors: function noErrors(state) {
      return !state.messages.some(function (message) {
        return message.type == 'error';
      });
    }
  },
  mutations: {
    addMessage: function addMessage(state, message) {
      var messages = state.messages;
      messages.push(message);
      state.messages = messages;
    },
    removeMessage: function removeMessage(state, key) {
      var messageArray = state.messages;
      var indexInArray = messageArray.findIndex(function (message) {
        return message.key == key;
      });
      messageArray.splice(indexInArray, 1);
      state.messages = messageArray;
    }
  },
  actions: {
    addMessage: function addMessage(context, _ref) {
      var text = _ref.text,
          title = _ref.title,
          type = _ref.type,
          duration = _ref.duration;
      var key = context.getters.getMessages.length;

      if (duration) {
        context.commit('addMessage', {
          text: text,
          title: title,
          type: type,
          key: key
        });
        setTimeout(function () {
          context.commit('removeMessage', key);
        }, duration);
      } else {
        context.commit('addMessage', {
          text: text,
          title: title,
          type: type,
          key: key
        });
      }
    }
  }
};
var _default = messages;
exports["default"] = _default;


// WEBPACK FOOTER //
// ../capital-finder-vuex/lib/modules/messages.js